module.exports = __webpack_public_path__ + "static/media/exam.97a9d561.svg";